export default __webpack_public_path__ + "static/media/mercury_symbol.1dda17cd.png";